import {Injectable} from '@angular/core';

import {WORD_SAJA_BOOKMARK_API_URL} from '../../defines/protocol';
import {ApiService} from '../api/api.service';
import {WordBookmarkService} from './word-bookmark.service';

@Injectable()
export class SajaseungeoBookmarkService extends WordBookmarkService {
  constructor(
    protected override api: ApiService,
  ) {
    super(api);
    this.urlApi = WORD_SAJA_BOOKMARK_API_URL;
  }
}
